import {
    type GetGenericInfoByKeyResponseType,
    type GetGenericInfoByKeyRequestType
} from "./type";
import {
    request
} from "../request";

const getGenericInfoByKey = async (params: GetGenericInfoByKeyRequestType): Promise<GetGenericInfoByKeyResponseType> => {
    return await request<GetGenericInfoByKeyResponseType>("/content/getGenericInfoByKey", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default getGenericInfoByKey;
